import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter } from 'react-router';
import { ModuleIndex, NotFound, RequirePermission, } from '#src/app/navigation/RouteGuards.js';
import { AppShell } from '#src/app/shell/AppShell.js';
import { RouteError } from '#src/app/shell/RouteError.js';
import { HomePage } from '#src/modules/home/HomePage.js';
/** Uma página (ou detalhe) só para quem tem a permissão, carregada sob demanda. */
const guarded = (page) => ({
    path: page.path,
    element: _jsx(RequirePermission, { permission: page.permission }),
    children: [
        { index: true, lazy: async () => ({ Component: await page.load() }) },
    ],
});
function moduleRoutes(module) {
    return {
        path: module.path,
        children: [
            { index: true, element: _jsx(ModuleIndex, { module: module }) },
            ...module.pages.map(guarded),
            ...(module.routes ?? []).map(guarded),
        ],
    };
}
export function createRouter(modules) {
    return createBrowserRouter([
        {
            path: '/',
            element: _jsx(AppShell, {}),
            errorElement: _jsx(RouteError, {}),
            children: [
                { index: true, element: _jsx(HomePage, {}) },
                ...modules.map(moduleRoutes),
                { path: '*', element: _jsx(NotFound, {}) },
            ],
        },
    ]);
}
//# sourceMappingURL=router.js.map